module.exports = {

    getDuration(date) {
        var dt = date?.split('-')
        var d = dt?.[2]?.split(' ')
        var time = d?.[1]?.split('T')

        const diffTime = Math.abs(new Date() - (new Date(`${dt?.[1]}-${dt?.[0]}-${d?.[0]}-${time?.[1].split(' ')?.[0]}`)));

        let seconds = (diffTime / 1000).toFixed(1);
        let minutes = (diffTime / (1000 * 60)).toFixed(1);
        let hours = (diffTime / (1000 * 60 * 60)).toFixed(1);
        let days = (diffTime / (1000 * 60 * 60 * 24)).toFixed(1);
        if (seconds < 60) return parseInt(seconds) + " Sec";
        else if (minutes < 60) return parseInt(minutes) + " Min";
        else if (hours < 24) return parseInt(hours) + " Hrs";
        else return parseInt(days) + " Days"
    },

    getDDMMYYYY(date) {
        var dt = date?.split('-')
        return `${dt?.[2]}-${dt?.[1]}-${dt?.[0]}`
    }
}